import { useContext, useEffect, useState } from "react";
import { CashRegisterDto } from "../../../../dtos/catalogs/cashregister/CashRegisterDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import CashRegisterDetailSkeleton from "./CashRegisterDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import CashRegisterDetailMain from "./CashRegisterDetailMain";

interface IProps {
  model: CashRegisterDto | null;
  modelUpdatedEvent: (newModel: CashRegisterDto) => void;
}

interface CashRegisterModel {
  id: string;
  name?: string;
  companyId?: string;
  currencyId?: string;
  uniqueCode?: string;
  divisionId?: string;
  createdDate?: Date;
}

export const CashRegisterDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<CashRegisterModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("companyId", model.companyId);
      setValue("currencyId", model.currencyId);
      setValue("divisionId", model.divisionId);
      setValue("createdDate", model.createdDate);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: CashRegisterModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: CashRegisterDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <CashRegisterDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <CashRegisterDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
